import type { ChatMessage } from "@/lib/chatApi";

const MAX_THREADS = 40;
const cache = new Map<number, ChatMessage[]>();

export function readChatThreadCache(conversationId: number): ChatMessage[] | null {
  if (conversationId < 1) return null;
  const hit = cache.get(conversationId);
  return hit ? hit.slice() : null;
}

export function writeChatThreadCache(conversationId: number, messages: ChatMessage[]): void {
  if (conversationId < 1) return;
  if (cache.has(conversationId)) cache.delete(conversationId);
  cache.set(conversationId, messages.slice());
  while (cache.size > MAX_THREADS) {
    const first = cache.keys().next().value;
    if (first == null) break;
    cache.delete(first);
  }
}
